var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('div',{staticClass:"container-sm py-5"},[_c('div',{staticClass:"loading py-5"},[_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":"/design/sigofood-images/loading-gif.gif","alt":"loading"}}),_c('p',[_vm._v("Loading...")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }